
export enum ProjectExamType {
	DESCRIPTIVE = "DESCRIPTIVE", // 서술형
	ESSAY = "ESSAY" // 논술형

	// MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
}
